import Vue from 'vue'
import VueRouter from 'vue-router'
import LowCode from '../views/LowCode.vue'
import { i18n } from '../i18n/index' //国际化
import Preview from '../views/Preview.vue'
import FrontPreview from '../views/front/Preview.vue'
// import test from '../views/front/mytest.vue'
import routerList from './router.js'
Vue.use(VueRouter)
const routes = []
if (process.env.NODE_ENV === 'production') {
	if (routes.length == 0) {
		if(process.env.VUE_APP_ENV == 'design') {
			routes.push({
				path: '/admin/:id/design',
				name: 'lowCode',
				component: LowCode
			})
		}
		if (process.env.VUE_APP_ENV == 'web') {
			routes.push({
				path: '/',
				name: 'FrontPreview',
				component: FrontPreview,
			},...routerList)
		}
	}
} else {
	if (routes.length == 0) {
		routes.push({
			path: '/design',
			name: 'lowCode',
			component: LowCode
		}, {
			path: '/',
			name: 'FrontPreview',
			component: FrontPreview,
			meta:{
				title:"h.home",
				id:""
			},
		},...routerList)
	}
}
const router = new VueRouter({
	mode: process.env.NODE_ENV === 'development'?'hash':'history',
	base: '/',
	routes
})
router.beforeEach((to, from, next) => {
	
	i18n.t(to.meta.title) && (document.title = i18n.t(to.meta.title));
	
	if(to.path == '/'){
		document.title = i18n.t('h.home')
	}
	
	if(to.path.endsWith('/design')){
		document.title = '可视化装修'
	}
	
	
	let domain = window.location.host;
	console.log(window.location);
	if (process.env.NODE_ENV != 'development') {
		next()
		console.log(domain);
		console.log('to', to)
		console.log('development', process.env.NODE_ENV)
	} else {
		next()
	}
})

export default router